import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LogsService } from '@services/logs';
import { CustomError } from '@shared/models';
import { map, Observable, Subject, takeUntil, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  private cancel$: Subject<boolean> = new Subject<boolean>();

  readonly #router = inject(Router);
  readonly #logsService = inject(LogsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse && event.status === 204 && event.headers.has('x-redirect-to')) {
          this.#logsService.info('ResponseInterceptor', `Redirecting to ${event.headers.get('x-redirect-to')}`);
          void this.#router.navigate([event.headers.get('x-redirect-to')]);
          this.cancel$.next(true);
        }
        return event;
      }),
      takeUntil(this.cancel$),
      catchError((e) => {
        if (e instanceof HttpErrorResponse) {
          // Skip logging for GCP log endpoint errors to prevent infinite recursion
          const isGcpLogsCall = e.url?.includes('/logs?namespace=') ?? false;
          if (e.status === 0 && !isGcpLogsCall) {
            this.#logsService.error('ResponseInterceptor', 'Server access problems', {
              url: req.url,
              method: req.method,
            });
            this.cancel$.next(true);
          }
        }
        const { status, error } = e as CustomError;
        return throwError(() => ({
          server: e as HttpErrorResponse,
          error,
          status,
        }));
      })
    );
  }
}
